// extracted by mini-css-extract-plugin
export default {"formContainer":"Form_formContainer__zEQIh","privacyPolicyUrl":"Form_privacyPolicyUrl__rn+Vo","footer":"Form_footer__erfLB"};